export default {
    accounts: []
}